<template>
  <b-modal
    id="lightbox"
    ref="modal"
    modal-class="lightbox"
    content-class="bg-transparent border-0"
    header-text-variant="light"
    header-class="border-0 p-0"
    body-text-variant="light"
    hide-footer
    @shown="onShown"
  >
    <Flickity
      ref="flickity"
      :options="options"
      class="vh-100"
    >
      <slot>
        <div
          v-for="image in images"
          :key="image.id || image"
          class="carousel-cell d-flex justify-content-center align-items-center w-100 h-100 overflow-hidden mr-4"
        >
          <img
            :src="image.data || image"
            alt=" "
            class="mw-100 mh-100"
          >
        </div>
      </slot>
    </Flickity>
  </b-modal>
</template>

<script>
import Flickity from 'vue-flickity';

export default {
  name: 'Lightbox',
  components: {
    Flickity,
  },
  props: {
    images: Array,
  },
  data() {
    return {
      options: {
        initialIndex: 0,
        setGallerySize: false,
      }
    }
  },
  methods: {
    show(index) {
      this.options.initialIndex = index
      this.$refs.modal.show()
    },
    onShown() {
      this.$refs.flickity.resize()
      this.$refs.flickity.$el.focus()
      enableParallax(this.$refs.flickity)
    },
  },
}

function enableParallax(component) {
  // from https://codepen.io/desandro/pen/qNPbgb

  const flkty = component.flickity()
  const imgs = component.$el.querySelectorAll('.carousel-cell img')
  // get transform property
  const docStyle = document.documentElement.style
  const transformProp = typeof docStyle.transform === 'string' ?
    'transform' : 'WebkitTransform'

  if (!imgs.length) { return }
  flkty.on('scroll', function() {
    flkty.slides.forEach( function( slide, i ) {
      const img = imgs[i]
      const x = ( slide.target + flkty.x ) * -1/3
      img.style[ transformProp ] = 'translateX(' + x  + 'px)'
    })
  })
}
</script>

<style lang="scss">
.lightbox {
  $offset: 4vw;
  $shadow: 0 2px 0 rgba(black,0.75);

  // modal

  .modal-dialog {
    max-width: none;
    margin: 0;
    height: 100vh;
  }
  .modal-body {
    padding: 0;
  }
  ~ .modal-backdrop {
    &.fade { opacity: 0; }
    &, &.show { opacity: 0.75; }
  }
  .close {
    opacity: 0.75;
    text-shadow: $shadow;
    font-weight: normal;
    font-size: 3rem;
    line-height: 0.75;
    position: absolute;
    top: ($offset/2);
    right: $offset;
    z-index: 2;
    &:not(:disabled):not(.disabled):hover {
      opacity: 1;
    }
  }

  // animation

  // remove slide down animation from modal
  &.modal.fade .modal-dialog {
    transform: none;
  }
  // add zoom in to image
  .flickity-viewport {
    transition: transform 0.3s;
  }
  &.modal.fade:not(.show) .flickity-viewport {
    transform: scale(0.95);
  }

  // flickity

  .flickity-slider {
    display: flex;
    align-items: center;
  }
  .flickity-page-dots {
    bottom: $offset;
    .dot {
      background: white;
    }
  }
  .flickity-button-icon {
    fill: rgba(white, 0.75);
    filter: drop-shadow($shadow);
    &:hover,
    &:focus {
      fill: white;
    }
  }
  .flickity-prev-next-button {
    background: none;
    &.previous { left: $offset; }
    &.next { right: $offset; }
  }
}
</style>
